// import React from "react";
// import Button from "../Buttons/Button";
// import { motion } from "framer-motion";

// const TimeSheetTooltip = ({ position, onClose, workDetail }) => {
//   if (!position) return null;

//   return (
//     <motion.div
//       initial={{ opacity: 0, scale: 0.95 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.95 }}
//       transition={{ duration: 0.2 }}
//       className="fixed z-50 bg-white rounded-lg shadow-lg p-3 min-w-[300px] timesheet-tooltip"
//       style={{
//         top: `${position.y}px`,
//         left: `${position.x}px`,
//         transform: "none", // Remove transform to align with cell's top-left corner
//       }}
//     >
//       <div className="flex flex-col gap-2">
//         <div className="flex items-center justify-between border-b pb-2">
//           <span className="text-sm font-medium">
//             {/* {workDetail.working} Hours */}
//             Actions
//           </span>
//           <Button
//             type="icon"
//             variant="text"
//             color="black"
//             icon="close"
//             onClick={onClose}
//             className="!p-1"
//           />
//         </div>
//         {/* <Button
//           title="Approve Selected Timesheets"
//           variant="text"
//           color="black"
//           className="!justify-start"
//           //   onClick={() => console.log("Edit time:", workDetail)}
//         /> */}
//         <div className="p-5 flex flex-col gap-2">
//           <Button
//             title="Approve Selected Timesheets"
//             color="black"
//             className="!justify-start !bg-success-100 !border-success-100 !text-black"
//             size="sm"
//           />
//           <Button
//             title="Reject Selected Timesheets"
//             color="black"
//             className="!justify-start  !bg-danger-100 !border-danger-100 !text-black"
//             size="sm"
//           />
//           <Button
//             title="Reset Selected Timesheets"
//             color="black"
//             className="!justify-start  !bg-draft-100 !border-draft-100 !text-black"
//             size="sm"
//           />
//           <Button
//             title="Mark as Invoiced"
//             color="black"
//             className="!justify-start  !bg-invoiced-100 !border-invoiced-100 "
//             size="sm"
//           />
//           <Button
//             title="Download Attachments"
//             color="black"
//             //className="!justify-start gray"
//             className="!justify-start  !bg-gray-500 !border-gray-500 "
//             size="sm"
//           />
//           <Button
//             title="Export Selected Timesheets"
//             color="black"
//             className="!justify-start"
//             size="sm"
//           />
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// export default TimeSheetTooltip;



import React, { useEffect, useRef, useState } from "react";
import Button from "../Buttons/Button";
import { motion } from "framer-motion";

const TimeSheetTooltip = ({
  position,
  onClose,
  workDetail,
  timesheetId,
  handleActions,
  selectedDate,
  selectedUser,
}) => {
  const tooltipRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState(null);

  useEffect(() => {
    if (!position || !tooltipRef.current) return;

    const tooltip = tooltipRef.current;
    const tooltipHeight = tooltip.offsetHeight;
    const tooltipWidth = tooltip.offsetWidth;

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let { x, y } = position;

    // Flip vertically if not enough space below
    if (y + tooltipHeight > viewportHeight) {
      y = y - tooltipHeight;
    }

    // Flip horizontally if not enough space to the right
    if (x + tooltipWidth > viewportWidth) {
      x = x - tooltipWidth;
    }

    // Ensure it doesn't go above the viewport
    if (y < 0) y = 8;

    // Ensure it doesn't go off the left edge
    if (x < 0) x = 8;

    setAdjustedPosition({ x, y });
  }, [position, tooltipRef.current?.offsetHeight]);

  if (!position) return null;
  console.log("modaldata triggered::::::::::");
  console.log("workDetail", workDetail);
  // console.log("selectedUser", selectedUser);
  // console.log("selectedDate", selectedDate);

  return (
    <motion.div
      ref={tooltipRef}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.2 }}
      className="fixed z-50 bg-white rounded-lg shadow-lg p-3 min-w-[300px] timesheet-tooltip"
      style={{
        // Use adjustedPosition once calculated, otherwise render off-screen to measure
        top: adjustedPosition ? `${adjustedPosition.y}px` : "-9999px",
        left: adjustedPosition ? `${adjustedPosition.x}px` : "-9999px",
        visibility: adjustedPosition ? "visible" : "hidden",
      }}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between border-b pb-2">
          <span className="text-sm font-medium">
            {/* {workDetail.working} Hours */}
            Actions
          </span>
          <Button
            type="icon"
            variant="text"
            color="black"
            icon="close"
            onClick={onClose}
            className="!p-1"
          />
        </div>
        {/* <Button
          title="Approve Selected Timesheets"
          variant="text"
          color="black"
          className="!justify-start"
          //   onClick={() => console.log("Edit time:", workDetail)}
        /> */}
        <div className="p-5 flex flex-col gap-2">
          <Button
            title="Approve Selected Timesheets"
            color="black"
            className="!justify-start !bg-success-100 !border-success-100 !text-black"
            size="sm"
            onClick={() => handleActions("approve", timesheetId)}
          />
          <Button
            title="Reject Selected Timesheets"
            color="black"
            className="!justify-start  !bg-danger-100 !border-danger-100 !text-black"
            size="sm"
            onClick={() => handleActions("reject", timesheetId)}
          />
          <Button
            title="Reset Selected Timesheets"
            color="black"
            className="!justify-start  !bg-draft-100 !border-draft-100 !text-black"
            size="sm"
            onClick={() => handleActions("reset", timesheetId)}
          />
          <Button
            title="Mark as Invoiced"
            color="black"
            className="!justify-start  !bg-invoiced-100 !border-invoiced-100 "
            onClick={() => handleActions("markAsInvoiced", timesheetId)}
            size="sm"
          />
          <Button
            title="Download Attachments"
            color="black"
            //className="!justify-start gray"
            className="!justify-start  !bg-gray-500 !border-gray-500 "
            size="sm"
            onClick={() => handleActions("download", timesheetId)}
          />
          <Button
            title="Export Selected Timesheets"
            color="black"
            className="!justify-start"
            size="sm"
            onClick={() => handleActions("export", timesheetId)}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default TimeSheetTooltip;
